export class GetFaq {
    static readonly type = '[FAQ] GetFAQ';
}
